// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  display: flex;
  width: 100%;
  height: 100vh;
  position: relative;
}
#container app-side-navbar {
  position: fixed;
  width: 250px;
  height: 100vh;
  background: black;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
}
#container #content {
  flex-grow: 1;
  transition: 0.3s ease-in-out;
}
#container.sidebarActive app-side-navbar {
  transform: translateX(0);
}
#container.sidebarActive #content {
  margin-left: 250px;
  transition: 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/features/asset-management/auth-tools/asset-management-authoring-tools/asset-management-authoring-tools.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAAJ;AACI;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,4BAAA;EACA,sCAAA;AACR;AAEI;EACI,YAAA;EACA,4BAAA;AAAR;AAIQ;EAEI,wBAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,4BAAA;AAJZ","sourcesContent":["\n#container{\n    display: flex;\n    width: 100%;\n    height:100vh;\n    position: relative;\n    app-side-navbar{\n        position: fixed;\n        width:250px;\n        height: 100vh;\n        background: black;\n        transform: translateX(-100%);\n        transition: transform 0.3s ease-in-out;\n    }\n\n    #content{\n        flex-grow: 1;\n        transition:  0.3s ease-in-out ;\n    }\n\n    &.sidebarActive{\n        app-side-navbar{\n            \n            transform: translateX(0);\n           \n        }\n        #content{\n            margin-left: 250px;\n            transition: 0.3s ease-in-out;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
